// extracted by mini-css-extract-plugin
export var content = "Modal-module--content--08c43";